module.exports = __webpack_public_path__ + "img/acryprint_info3.e875e4bc.png";